import React, {Component} from 'react';
import {ACTION_TYPES, actions} from "../../actions";
import {connect} from "react-redux";
import Loader from 'react-loader';
import ArtifactReviewTable from './ArtifactReviewTable';
import CommentList from './CommentList';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {withStyles} from "@material-ui/core/styles/index";
import Typography from '@material-ui/core/Typography';
import {ROLES, withRoles} from "../Permissions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import _ from 'lodash';

import ValidationSnackBar from '../parts/ValidationSnackBar';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {BASENAME} from "../../constants";

const styles = {
    card: {
        minWidth: 275,
        marginBottom: 15
    },
    title: {
        marginTop: 5,
        marginBottom: -2,
        fontSize: 12,
    },
    p: {
        marginBottom: 5
    },
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        padding: 16,
        marginBottom: -25
    }

};

class Review extends Component {

    constructor(props) {
        super(props);
        this.reviewRef = React.createRef();
        this.state = {
            cardHeight:300,
            loaded: false,
            scoreUpdateSnackBarOpen: false,
            showButton: true,
            open: false
        };
        this.handleForbidden = this.handleForbidden.bind(this);

    }

    handleForbidden() {
        this.props.history.push('/forbidden');
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleCloseDialog = () => {
        this.setState({ open: false });
    };


    async componentDidMount() {
        const {assessment_id} = this.props.match.params;
        let res = await fetch(BASENAME + '/api/review/' + assessment_id);
        if(res.status == 200) {
            let assessment = await res.json();
            let payload = assessment;

            this.props.setAssessment(payload);

            this.setState({loaded: true});
            var reviewerObject = assessment.reviewers.filter(reviewer => {
                return reviewer.unid === this.props.user.unid;
            })
            let reviewer = reviewerObject[0];
            if(reviewer.finished) {
                this.setState({showButton: false});
            }
        } else {
            this.handleForbidden();
        }
        this.setState({
            cardHeight:this.reviewRef.current.clientHeight
        })

    }


    handleSubmitScores = async () => {
        this.setState({loaded: false});
        const {assessment_id} = this.props.match.params;
        const body = {reviewers: this.props.reviewers};
        const updatedAssessment = await this.props.updateAssessment(assessment_id, body);
        this.setState({scoreUpdateSnackBarOpen: true});
        this.setState({loaded: true});
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({
            scoreUpdateSnackBarOpen: false,
        });
    };

    handleFinalize = async () => {
        var reviewerObject = this.props.reviewers.filter(reviewer => {
            return reviewer.unid === this.props.user.unid;
        })
        let reviewer = reviewerObject[0];
        reviewer.finished = true;
        this.props.updateReviewer(reviewer);


        this.setState({loaded: false});
        const {assessment_id} = this.props.match.params;
        const body = {reviewers: this.props.reviewers, finishedReviewer: reviewer};
        const updatedAssessment = await this.props.updateAssessment(assessment_id, body);
        this.setState({scoreUpdateSnackBarOpen: true});
        this.setState({loaded: true, showButton: false, open: false});
    };

    renderSnackBars() {
        return (<div>
            <ValidationSnackBar
                variant="success"
                message={"Score Updated"}
                open={this.state.scoreUpdateSnackBarOpen}
                onClose={this.handleClose}
            />
        </div>)
    }

    renderButton() {
        var reviewerObject = this.props.reviewers.filter(reviewer => {
            return reviewer.unid === this.props.user.unid;
        })
        let reviewer = reviewerObject[0];
        let finished = !reviewer.artifactScores.find(artifactScore => artifactScore.rubricScores.includes(null));

        if(this.state.showButton) {
            if(finished) {
                return(<Button variant="contained" color="secondary" onClick={this.handleClickOpen}>
                    Finalize
                </Button>);
            }
        } else{
            return(<div></div>)
        }
    }

    renderTerms(terms) {
        let stringTerms =  _.map(terms, option => {
            return option.name;
        });
        let str = stringTerms.toString();
        return str.replace(/,/g, ', ');
    }


    render() {
        const {classes, form} = this.props;
        let visible = null;
        if (this.state.loaded) {
            visible = (
                <div>
                    <Grid
                        justify="space-between"
                        container
                        spacing={24}
                    >
                        <Grid item>
                            <Typography variant="h5" gutterBottom>
                                Review {form.name}
                            </Typography>
                        </Grid>

                        <Grid item>
                            {this.renderButton()}
                        </Grid>
                    </Grid>

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Do you want will finalize your review? "}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                You will not be able to edit your scores.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseDialog} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.handleFinalize} color="primary" autoFocus>
                                Agree
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Grid container spacing = {1}>
                        <Grid item xs={6}>
                            <Card className={classes.card}>
                                <CardContent ref={this.reviewRef}>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Assessment Name
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {form.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        College
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {form.college.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Department
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {form.department.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Program
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {form.program.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Term
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.renderTerms(form.terms)}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Outcome
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {form.outcome.name}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card style = {{height:this.state.cardHeight}}>
                                <CardContent>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Comments
                                    </Typography>
                                    <React.Fragment>
                                        <CommentList isReview={true}/>
                                    </React.Fragment>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    <Card className={classes.card}>
                        <Typography variant="h5" gutterBottom className={classes.headertitle}>
                            Artifacts
                        </Typography>
                        <CardContent>
                            <div className='row' style={{paddingBottom: '20px'}}>
                                <ArtifactReviewTable changed={false} hideActions={true}/>
                            </div>
                        </CardContent>
                    </Card>

                </div>
            )
        }
        return (
            <div>
                <Loader loaded={this.state.loaded}/>
                <br/>
                {visible}
                {this.renderSnackBars()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        form: state.newAssessmentForm,
        artifacts: state.artifacts,
        rubrics: state.rubrics,
        reviewers: state.reviewers
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)((withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN, ROLES.REVIEWER])(Review))));

